
import bulb from "../../../assets/images/bulb-sketch.svg";
import creative from "../../../assets/images/creative-sketch.svg";
import { FiArrowUpRight } from "react-icons/fi";

function WhatWeDo() {
  const items = [
    {
      id: 1,
      text: "Graphic Design",
    },
    {
      id: 2,
      text: "Brand  identity",
    },
    {
      id: 3,
      text: "App Development",
    },
    {
      id: 4,
      text: "Product  Design",
    },
    {
      id: 5,
      text: "Content Creation",
    },
    {
      id: 6,
      text: "Project Management",
    },
    {
      id: 7,
      text: "Web design",
    },
  ];

  return (
    <section className="what bg-bg-white md:min-h-[1000px] min-h-screen px-[16px] md:px-0 relative overflow-hidden ">
      <div className="container mx-auto">
        <div className="flex items-center justify-center z-50 relative py-[64px]">
          <h3 className="font-bold md:text-[48px] leading-[56px] text-[28px] pr-2">
            What we do
          </h3>
          <img
            src={bulb}
            className="md:h-[69px] md:w-[69px] h-[44px] w-[44px] object-cover pointer-events-none"
            alt="Bulb"
          />
        </div>
        <div className="flex md:items-center md:justify-center md:w-full mx-[16px] md:mt-[10px] ">
          <div>
            <div className="what-inner-circle h-[451px] w-[451px] rounded-[50%] absolute left-[50%] top-[300px] bg-white md:flex items-center justify-center hidden">
              <img
                src={creative}
                alt=""
                className="w-full pointer-events-none"
              />
            </div>
            <div className="hidden md:block what-outer-circle mx-auto h-[649px] w-[649px] absolute bottom-0 left-[640px] right-0 top-[200px] rounded-[50%] opacity-80"></div>
            <div className="z-40 w-[800px]  absolute items_container">
              {items.map((item, i) => (
                <div
                  className={`absolute bg-black rounded-[25px] md:py-4 md:px-4 py-2 px-2 flex items-center justify-center w-[176px] md:w-[223px] cursor-pointer what-animation child-${item.id}`}
                  key={i}
                >
                  <div className="flex items-center">
                    <h3 className="text-white font-sfpro md:text-lg text-sm">
                      {item.text}
                    </h3>
                    <FiArrowUpRight
                      size={20}
                      className="md:ml-3 ml-1 text-white"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
